<template>
  <div class="plan">
    <el-header>
      <div class="vehicle">车辆监控大屏</div>

      <div class="tiem">
        <el-form :model="form" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item>
            <el-date-picker class="time1" v-model="form.date1" type="datetime" placeholder="选择起始日期"></el-date-picker>
            <el-date-picker class="time1" v-model="form.date2" type="datetime" placeholder="选择截止日期"></el-date-picker>
            <el-button class="time2" type="primary" @click="submitForm('ruleForm')">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="tiem9">
        <span class="tiem9-inquire">车牌查询：</span>
        <el-autocomplete
          class="inline-input tiem9-inline"
          v-model="state1"
          :fetch-suggestions="querySearch"
          placeholder="请输入内容"
          @select="handleSelect"
        >
          <i
            class="el-icon-search el-input__icon planM-search"
            slot="suffix"
            @click="handleIconClick"
          ></i>
          <template slot-scope="{ item }">
            <div class="name">{{ item.licence }}</div>
          </template>
        </el-autocomplete>
      </div>
    </el-header>
    <el-main class="plan-main">
      <el-row class="plan-designation">
        <el-col style="width: 41%;">线路KPI</el-col>
        <el-col style="width: 46%;margin-left: 7px;">车辆KPI</el-col>
        <el-col style="width: 12%;margin-left: 7px;">车辆循环次数</el-col>
      </el-row>
      <el-row>
        <el-col style="width: 41%;margin-right: 0px;">
          <div class="main_table t_btn2">
            <el-table
              :header-cell-style="{backgroundColor:'transparent',color:'#ffffff',fontSize:'15px',textAlign:'left'}"
              :cell-style="{color: '#fff',backgroundColor:'transparent',fontSize:'13px',textAlign:'left'}"
              :row-style="{color: '#fff',backgroundColor:'transparent',fontSize:'13px',textAlign:'left'}"
              :data="tableData2"
              @row-click="clickSkip"
              height="350px"
              style="width: 100%; box-shadow: #80c5ff 0px 0px 18px inset;"
            >
              <el-table-column prop="origin" label="起点停留时间" column-key="date">
                <template slot-scope="scope">
                  <div class="scop-div">{{ scope.row.origin }}</div>
                  <span style="margin-left: 10px">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="scope.row.origin1+'分钟'"
                      placement="top-start"
                    >
                      <div class="plan-expectation" :style="{width: scope.row.origin1+ 50 + 'px'}">
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="scope.row.origin2+'分钟'"
                          placement="top-start"
                        >
                          <div
                            class="plan-practical"
                            :class="scope.row.origin1>scope.row.origin2 ?'hue':''"
                            :style="{width: scope.row.origin2+ 50 + 'px'}"
                          ></div>
                        </el-tooltip>
                      </div>
                    </el-tooltip>
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="terminus" label="终点停留时间">
                <template slot-scope="scope">
                  <div class="scop-div">{{ scope.row.terminus }}</div>
                  <span style="margin-left: 10px">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="scope.row.terminus1+'分钟'"
                      placement="top-start"
                    >
                      <div
                        class="plan-expectation"
                        :style="{width: scope.row.terminus1+ 50 + 'px'}"
                      >
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="scope.row.terminus2+'分钟'"
                          placement="top-start"
                        >
                          <div
                            class="plan-practical"
                            :class="scope.row.terminus1>scope.row.terminus2 ?'hue':''"
                            :style="{width: scope.row.terminus2+ 50 + 'px'}"
                          ></div>
                        </el-tooltip>
                      </div>
                    </el-tooltip>
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="passage" label="在途时间">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="scope.row.passage1+'分钟'"
                      placement="top-start"
                    >
                      <div class="plan-expectation" :style="{width: scope.row.passage1+ 50 + 'px'}">
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="scope.row.passage2+'分钟'"
                          placement="top-start"
                        >
                          <div
                            class="plan-practical"
                            :class="scope.row.passage1>scope.row.passage2 ?'hue':''"
                            :style="{width: scope.row.passage2+ 50 + 'px'}"
                          ></div>
                        </el-tooltip>
                      </div>
                    </el-tooltip>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
        <el-col style="width: 46%;margin-left: 7px;">
          <div class="main_table t_btn2 t_btn88">
            <el-table
              :header-cell-style="{backgroundColor:'transparent',color:'#ffffff',fontSize:'15px',textAlign:'center'}"
              :cell-style="cellStyle"
              :row-style="{color: '#fff',backgroundColor:'transparent',fontSize:'13px',textAlign:'center'}"
              :data="plateData"
              height="350px"
              style="width: 100%; box-shadow: #80c5ff 0px 0px 18px inset; "
            >
              <el-table-column prop="licence" label="车牌" column-key="date"></el-table-column>
              <el-table-column prop="warehouse" label="华迅仓库" width="80px">
                <template slot-scope="scope" v-if="scope.row.warehouse">{{ scope.row.warehouse }}分钟</template>
              </el-table-column>
              <el-table-column prop="deepwater" label="深水港" width="70px">
                <template slot-scope="scope" v-if="scope.row.deepwater">{{ scope.row.deepwater }}分钟</template>
              </el-table-column>
              <el-table-column prop="wharf" label="洋山码头" width="80px">
                <template slot-scope="scope" v-if="scope.row.wharf">{{ scope.row.wharf }}分钟</template>
              </el-table-column>
              <el-table-column prop="storage" label="普捷通堆场" width="95px">
                <template slot-scope="scope" v-if="scope.row.storage">{{ scope.row.storage }}分钟</template>
              </el-table-column>
              <el-table-column prop="line" label="线路" width="100px"></el-table-column>
              <el-table-column prop="travel" label="行驶时间"></el-table-column>
              <el-table-column prop="travel" label="异常">
                <template slot-scope="scope">
                  <!-- <span v-if="scope.row.abnormal" style="margin-left: 10px">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="scope.row.abnormal"
                      placement="top-start"
                    >
                      <i class="el-icon-warning-outline"></i>
                    </el-tooltip>
                  </span>-->
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
        <el-col style="width: 12%;margin-left: 7px;">
          <div class="main_table t_btn2">
            <el-table
              :header-cell-style="{backgroundColor:'transparent',color:'#ffffff',fontSize:'15px',textAlign:'center'}"
              :cell-style="{color: '#fff',backgroundColor:'transparent',fontSize:'13px',textAlign:'center'}"
              :row-style="{color: '#fff',backgroundColor:'transparent',fontSize:'13px',textAlign:'center'}"
              :data="plateData2"
              height="350px"
              style="width: 100%; box-shadow: #80c5ff 0px 0px 18px inset;"
            >
              <el-table-column prop="licence" label="车牌" column-key="date" width="100px"></el-table-column>
              <el-table-column prop="cycle" label="循环次数"></el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </el-main>
    <el-footer style="position: relative;">
      <div
        id="echarts"
        :style="{  height: '400px' }"
        style="box-shadow: #80c5ff 0px 0px 18px inset; padding:20px;"
      ></div>
      <div class="plan-echarts">
        <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
    </el-footer>
  </div>
</template>

<script>
export default {
  mounted() {
    var date1 = new Date(new Date(new Date().toLocaleDateString()).getTime());
    var startTime =
      date1.getFullYear() +
      "-" +
      (date1.getMonth() + 1 < 10
        ? "0" + (date1.getMonth() + 1)
        : date1.getMonth() + 1) +
      "-" +
      (date1.getDate() < 10 ? "0" + date1.getDate() : date1.getDate()) +
      " " +
      (date1.getHours() < 10 ? "0" + 8 : date1.getHours()) +
      ":" +
      (date1.getMinutes() < 10
        ? "0" + date1.getMinutes()
        : date1.getMinutes()) +
      ":" +
      (date1.getSeconds() < 10 ? "0" + date1.getSeconds() : date1.getSeconds());
    var date2 = new Date(new Date(new Date().toLocaleDateString()).getTime());
    var endTime =
      date2.getFullYear() +
      "-" +
      (date2.getMonth() + 1 < 10
        ? "0" + (date2.getMonth() + 1)
        : date2.getMonth() + 1) +
      "-" +
      (date2.getDate() < 10 ? "0" + (date2.getDate() + 1) : date2.getDate()) +
      " " +
      (date2.getHours() < 10 ? "0" + 8 : date2.getHours()) +
      ":" +
      (date2.getMinutes() < 10
        ? "0" + date2.getMinutes()
        : date2.getMinutes()) +
      ":" +
      (date2.getSeconds() < 10 ? "0" + date2.getSeconds() : date2.getSeconds());
    this.form.date1 = startTime;
    this.form.date2 = endTime;
    // this.Bearer();
    // this.requestPlan();
    this.plateData = this.tableData;
    var echarts = require("echarts/lib/echarts");
    require("echarts/lib/chart/line");
    require("echarts/lib/component/title");
    var myChart = echarts.init(document.getElementById("echarts"));
    this.unit.data = [
      0,
      2,
      6,
      4,
      6,
      7,
      5,
      5,
      4,
      5,
      6,
      4,
      3,
      4,
      5,
      6,
      3,
      0,
      4,
      2,
      4,
      5,
      1,
      3
    ];
    var max = 0;
    for (let i in this.unit.data) {
      if (this.unit.data[i] > max) {
        max = this.unit.data[i];
      }
    }
    let tts = 0;
    if (max < 10) {
      tts = 10;
    } else {
      tts = 10 - (max % 10) + max;
    }
    this.unit.max = tts;
    // 绘制图表
    var option = {
      title: {
        text: "东海大桥潮汐图",
        textStyle: {
          fontWeight: "normal", //标题颜色
          color: "#f8f8f8"
        }
      },
      tooltip: {
        trigger: "axis"
      },

      legend: {
        data: ["速度", "普捷通单量"],
        textStyle: {
          color: "#4faaff"
        }
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true
      },

      // toolbox: {
      //   feature: {
      //     saveAsImage: {}
      //   }
      // },
      xAxis: {
        type: "category",
        axisPointer: {
          type: "shadow"
        },
        data: [
          "1h",
          "2h",
          "3h",
          "4h",
          "5h",
          "6h",
          "7h",
          "8h",
          "9h",
          "10h",
          "11h",
          "12h",
          "13h",
          "14h",
          "15h",
          "16h",
          "17h",
          "18h",
          "19h",
          "20h",
          "21h",
          "22h",
          "23h",
          "24h"
        ],
        axisLabel: {
          type: "shadow",
          textStyle: {
            color: "#4faaff"
          }
        }
      },
      yAxis: [
        {
          type: "value",
          // name: "订单量",
          min: 0,
          max: this.unit.max,
          interval: this.unit.max / 6,
          boundaryGap: false,
          //  show: false,

          nameTextStyle: {
            color: "#4faaff"
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#2b3f9b"
            }
          },

          axisLabel: {
            formatter: value => {
              //formatter拦截数据展示的方法
              return "";
              // let max = this.unit.data.reduce((a, b) => (a > b ? a : b));
              // if (max == 0) {
              //   return value;
              // } else {
              //   value = this.y_axis_data_display(max, value); //该方法是将展示的值转化成小于1024的数据
              //   return value + "个";
              // }
            },
            textStyle: {
              color: "#4faaff"
            }
          }
        },
        {
          type: "value",
          name: "车速",
          min: 0,
          max: 120,
          interval: 20,
          boundaryGap: false,
          nameTextStyle: {
            color: "#4faaff"
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#2b3f9b"
            }
          },
          axisLabel: {
            formatter: "{value} km/h",
            textStyle: {
              color: "#4faaff"
            }
          }
        }
      ],
      series: [
        {
          name: "速度",
          type: "bar",
          barWidth: 30,
          yAxisIndex: 1,
          itemStyle: {
            normal: {
              color: function(params) {
                if (params.value < 20) {
                  return "red";
                } else if (params.value > 40) {
                  return "green";
                } else {
                  return "#db752d";
                }
              },
              label: { color: "#000" },
              lineStyle: {
                color: "#000"
              }
            }
          },
          data: [
            10,
            20,
            50,
            40,
            50,
            60,
            50,
            50,
            40,
            50,
            60,
            20,
            50,
            40,
            50,
            60,
            30,
            10,
            30,
            14,
            30,
            40,
            10,
            20
          ]
        },
        {
          name: "普捷通单量",
          type: "line",
          itemStyle: {
            normal: {
              color: "#fff",
              label: { show: true },
              lineStyle: {
                color: "#fff"
              }
            }
          },
          data: this.unit.data
        }
      ]
    };

    myChart.setOption(option);
    var newArray = [];
    for (var i = 0; i < this.tableData.length; i++) {
      var result = false; //定义一个布尔变量，判断是否传入新数组元素
      for (var j = 0; j < newArray.length; j++) {
        if (this.tableData[i].licence == newArray[j].licence) {
          result = true;
          break;
        }
      }
      //alert(newArray[0])
      if (!result) {
        newArray.push(this.tableData[i]);
      }
    }
    this.tableDataTow = newArray;
    this.plateData2 = this.tableDataTow;
    this.restaurants = this.loadAll();
  },
  data() {
    return {
      unit: {
        max: 0,
        data: []
      },
      restaurants: [],
      state1: "",
      options: [
        {
          value: "选项1",
          label: "2020年11月15日"
        },
        {
          value: "选项2",
          label: "2020年11月16日"
        },
        {
          value: "选项3",
          label: "2020年11月17日"
        },
        {
          value: "选项4",
          label: "2020年11月18日"
        },
        {
          value: "选项5",
          label: "2020年11月19日"
        }
      ],
      value: "",
      form: {
        date1: "",
        date2: ""
      },
      plateData: [],
      plateData2: [],
      tableData2: [
        {
          origin: "华讯仓库",
          terminus: "深水港",
          origin1: 15,
          origin2: 18,
          terminus2: 29,
          terminus1: 30,
          passage2: 15,
          passage1: 15
        },
        {
          origin: "深水港",
          terminus: "洋山码头",
          origin1: 30,
          origin2: 29,
          terminus2: 54,
          terminus1: 40,
          passage2: 42,
          passage1: 45
        },
        {
          origin: "洋山码头",
          terminus: "深水港",
          origin1: 40,
          origin2: 54,
          terminus2: 29,
          terminus1: 30,
          passage2: 0,
          passage1: 0
        },
        {
          origin: "洋山码头",
          terminus: "普捷通堆场",
          origin1: 40,
          origin2: 54,
          terminus2: 24,
          terminus1: 20,
          passage2: 52,
          passage1: 50
        },
        {
          origin: "洋山码头",
          terminus: "华迅仓库",
          origin1: 40,
          origin2: 54,
          terminus2: 18,
          terminus1: 15,
          passage2: 45,
          passage1: 55
        },
        {
          origin: "普捷通堆场",
          terminus: "华迅仓库",
          origin1: 20,
          origin2: 24,
          terminus2: 18,
          terminus1: 15,
          passage2: 6,
          passage1: 6
        }
      ],
      tableData: [
        {
          licence: "沪EG7372",
          warehouse: "9",
          deepwater: "20",
          wharf: "",
          storage: "",
          line: "华讯仓库-深水港",
          travel: "14",
          cycle: "7",
          abnormal: "破损"
        },
        {
          licence: "沪DP5589",
          warehouse: "",
          deepwater: "25",
          wharf: "40",
          storage: "",
          line: "深水港-洋山码头",
          travel: "40",
          cycle: "5",
          abnormal: ""
        },
        {
          licence: "沪DP5635",
          warehouse: "",
          deepwater: "11",
          wharf: "40",
          storage: "",
          line: "深水港-洋山码头",
          travel: "31",
          cycle: "6",
          abnormal: ""
        },
        {
          licence: "沪DP5739",
          warehouse: "",
          deepwater: "10",
          wharf: "40",
          storage: "",
          line: "深水港-洋山码头",
          travel: "48",
          cycle: "5",
          abnormal: ""
        },
        {
          licence: "沪DP5756",
          warehouse: "15",
          deepwater: "20",
          wharf: "",
          storage: "",
          line: "华讯仓库-深水港",
          travel: "17",
          cycle: "6",
          abnormal: ""
        },
        {
          licence: "沪EG7372",
          warehouse: "",
          deepwater: "12",
          wharf: "40",
          storage: "",
          line: "深水港-洋山码头",
          travel: "47",
          cycle: "5",
          abnormal: ""
        },
        {
          licence: "沪DP5589",
          warehouse: "",
          deepwater: "",
          wharf: "83",
          storage: "20",
          line: "洋山码头-普捷通",
          travel: "46",
          cycle: "6",
          abnormal: ""
        },
        {
          licence: "沪DP5635",
          warehouse: "",
          deepwater: "",
          wharf: "54",
          storage: "20",
          line: "洋山码头-普捷通",
          travel: "45",
          cycle: "5",
          abnormal: ""
        },
        {
          licence: "沪DP5739",
          warehouse: "",
          deepwater: "",
          wharf: "39",
          storage: "20",
          line: "洋山码头-普捷通",
          travel: "45",
          cycle: "5",
          abnormal: ""
        },
        {
          licence: "沪DP5756",
          warehouse: "",
          deepwater: "41",
          wharf: "40",
          storage: "",
          line: "深水港-洋山码头",
          travel: "36",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪EG7372",
          warehouse: "",
          deepwater: "",
          wharf: "39",
          storage: "20",
          line: "洋山码头-普捷通",
          travel: "58",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪DP5589",
          warehouse: "",
          deepwater: "30",
          wharf: "",
          storage: "46",
          line: "普捷通-深水港",
          travel: "10",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪DP5635",
          warehouse: "",
          deepwater: "30",
          wharf: "",
          storage: "20",
          line: "普捷通-深水港",
          travel: "15",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪DP5739",
          warehouse: "15",
          deepwater: "",
          wharf: "",
          storage: "20",
          line: "普捷通-华迅",
          travel: "6",
          cycle: "7",
          abnormal: ""
        },
        {
          licence: "沪DP5756",
          warehouse: "",
          deepwater: "",
          wharf: "40",
          storage: "20",
          line: "洋山码头-普捷通",
          travel: "56",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪EG7372",
          warehouse: "",
          deepwater: "30",
          wharf: "",
          storage: "30",
          line: "普捷通-深水港",
          travel: "14",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪DP5589",
          warehouse: "",
          deepwater: "40",
          wharf: "40",
          storage: "",
          line: "深水港-洋山码头",
          travel: "42",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪DP5635",
          warehouse: "",
          deepwater: "14",
          wharf: "40",
          storage: "",
          line: "深水港-洋山码头",
          travel: "36",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪DP5739",
          warehouse: "",
          deepwater: "22",
          wharf: "40",
          storage: "",
          line: "深水港-洋山码头",
          travel: "40",
          cycle: "7",
          abnormal: ""
        },
        {
          licence: "沪DP5756",
          warehouse: "",
          deepwater: "30",
          wharf: "",
          storage: "45",
          line: "普捷通-深水港",
          travel: "15",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪EG7372",
          warehouse: "",
          deepwater: "16",
          wharf: "40",
          storage: "",
          line: "深水港-洋山码头",
          travel: "41",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪DP5589",
          warehouse: "15",
          deepwater: "",
          wharf: "73",
          storage: "",
          line: "洋山码头-华迅",
          travel: "45",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪DP5635",
          warehouse: "",
          deepwater: "",
          wharf: "42",
          storage: "20",
          line: "洋山码头-普捷通",
          travel: "46",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪DP5739",
          warehouse: "",
          deepwater: "",
          wharf: "44",
          storage: "20",
          line: "洋山码头-普捷通",
          travel: "52",
          cycle: "7",
          abnormal: ""
        },
        {
          licence: "沪DP5756",
          warehouse: "",
          deepwater: "28",
          wharf: "40",
          storage: "",
          line: "深水港-洋山码头",
          travel: "41",
          cycle: "7",
          abnormal: ""
        },
        {
          licence: "沪EG7372",
          warehouse: "",
          deepwater: "",
          wharf: "40",
          storage: "20",
          line: "洋山码头-普捷通",
          travel: "54",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪DP5589",
          warehouse: "33",
          deepwater: "30",
          wharf: "",
          storage: "",
          line: "华讯仓库-深水港",
          travel: "15",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪DP5635",
          warehouse: "25",
          deepwater: "30",
          wharf: "",
          storage: "",
          line: "华讯仓库-深水港",
          travel: "15",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪DP5739",
          warehouse: "15",
          deepwater: "",
          wharf: "",
          storage: "21",
          line: "普捷通-华迅",
          travel: "6",
          cycle: "7",
          abnormal: ""
        },
        {
          licence: "沪DP5756",
          warehouse: "",
          deepwater: "",
          wharf: "40",
          storage: "20",
          line: "洋山码头-普捷通",
          travel: "48",
          cycle: "7",
          abnormal: ""
        },
        {
          licence: "沪EG7372",
          warehouse: "15",
          deepwater: "",
          wharf: "",
          storage: "20",
          line: "普捷通-华迅",
          travel: "5",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪DP5589",
          warehouse: "",
          deepwater: "45",
          wharf: "40",
          storage: "",
          line: "深水港-洋山码头",
          travel: "42",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪DP5635",
          warehouse: "",
          deepwater: "27",
          wharf: "40",
          storage: "",
          line: "深水港-洋山码头",
          travel: "36",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪DP5739",
          warehouse: "11",
          deepwater: "30",
          wharf: "",
          storage: "",
          line: "华讯仓库-深水港",
          travel: "17",
          cycle: "7",
          abnormal: ""
        },
        {
          licence: "沪DP5756",
          warehouse: "6",
          deepwater: "",
          wharf: "",
          storage: "20",
          line: "普捷通-华迅",
          travel: "6",
          cycle: "7",
          abnormal: ""
        },
        {
          licence: "沪EG7372",
          warehouse: "13",
          deepwater: "20",
          wharf: "",
          storage: "",
          line: "华讯仓库-深水港",
          travel: "14",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪DP5635",
          warehouse: "15",
          deepwater: "",
          wharf: "86",
          storage: "",
          line: "洋山码头-华迅",
          travel: "46",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪DP5739",
          warehouse: "15",
          deepwater: "17",
          wharf: "",
          storage: "",
          line: "深水港-华讯仓库",
          travel: "15",
          cycle: "7",
          abnormal: ""
        },
        {
          licence: "沪DP5756",
          warehouse: "14",
          deepwater: "20",
          wharf: "",
          storage: "",
          line: "华讯仓库-深水港",
          travel: "13",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪EG7372",
          warehouse: "",
          deepwater: "12",
          wharf: "",
          storage: "20",
          line: "深水港-普捷通",
          travel: "10",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪DP5589",
          warehouse: "15",
          deepwater: "",
          wharf: "",
          storage: "21",
          line: "普捷通-华迅",
          travel: "6",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪DP5635",
          warehouse: "60",
          deepwater: "30",
          wharf: "",
          storage: "",
          line: "华讯仓库-深水港",
          travel: "15",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪DP5739",
          warehouse: "",
          deepwater: "",
          wharf: "40",
          storage: "30",
          line: "普捷通-洋山码头",
          travel: "50",
          cycle: "7",
          abnormal: ""
        },
        {
          licence: "沪DP5756",
          warehouse: "",
          deepwater: "43",
          wharf: "40",
          storage: "",
          line: "深水港-洋山码头",
          travel: "41",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪EG7372",
          warehouse: "",
          deepwater: "",
          wharf: "40",
          storage: "14",
          line: "普捷通-洋山码头",
          travel: "49",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪DP5589",
          warehouse: "15",
          deepwater: "30",
          wharf: "",
          storage: "",
          line: "华讯仓库-深水港",
          travel: "14",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪DP5635",
          warehouse: "",
          deepwater: "23",
          wharf: "",
          storage: "20",
          line: "深水港-普捷通",
          travel: "15",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪DP5756",
          warehouse: "",
          deepwater: "",
          wharf: "53",
          storage: "20",
          line: "洋山码头-普捷通",
          travel: "55",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪EG7372",
          warehouse: "",
          deepwater: "",
          wharf: "47",
          storage: "20",
          line: "洋山码头-普捷通",
          travel: "55",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪DP5589",
          warehouse: "",
          deepwater: "34",
          wharf: "40",
          storage: "",
          line: "深水港-洋山码头",
          travel: "44",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪DP5756",
          warehouse: "6",
          deepwater: "",
          wharf: "",
          storage: "30",
          line: "普捷通-华迅",
          travel: "5",
          cycle: "7",
          abnormal: ""
        },
        {
          licence: "沪EG7372",
          warehouse: "15",
          deepwater: "",
          wharf: "",
          storage: "39",
          line: "普捷通-华迅",
          travel: "5",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪DP5589",
          warehouse: "",
          deepwater: "",
          wharf: "57",
          storage: "20",
          line: "洋山码头-普捷通",
          travel: "57",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪EG7372",
          warehouse: "58",
          deepwater: "20",
          wharf: "",
          storage: "",
          line: "华讯仓库-深水港",
          travel: "14",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪DP5589",
          warehouse: "31",
          deepwater: "",
          wharf: "",
          storage: "20",
          line: "普捷通-华迅",
          travel: "6",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪EG7372",
          warehouse: "",
          deepwater: "30",
          wharf: "40",
          storage: "",
          line: "深水港-洋山码头",
          travel: "45",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪EG7372",
          warehouse: "",
          deepwater: "",
          wharf: "40",
          storage: "20",
          line: "洋山码头-普捷通",
          travel: "54",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪EG7372",
          warehouse: "25",
          deepwater: "",
          wharf: "",
          storage: "20",
          line: "普捷通-华迅",
          travel: "5",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪EG7372",
          warehouse: "15",
          deepwater: "20",
          wharf: "",
          storage: "",
          line: "华讯仓库-深水港",
          travel: "9",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪EG7372",
          warehouse: "15",
          deepwater: "13",
          wharf: "",
          storage: "",
          line: "深水港-华讯仓库",
          travel: "12",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪EC7513",
          warehouse: "",
          deepwater: "14",
          wharf: "40",
          storage: "",
          line: "深水港-洋山码头",
          travel: "42",
          cycle: "6",
          abnormal: ""
        },
        {
          licence: "沪EB7193",
          warehouse: "15",
          deepwater: "20",
          wharf: "",
          storage: "",
          line: "华讯仓库-深水港",
          travel: "15",
          cycle: "5",
          abnormal: ""
        },
        {
          licence: "沪EC7513",
          warehouse: "",
          deepwater: "",
          wharf: "58",
          storage: "20",
          line: "洋山码头-普捷通",
          travel: "50",
          cycle: "6",
          abnormal: ""
        },
        {
          licence: "沪EB7193",
          warehouse: "15",
          deepwater: "28",
          wharf: "",
          storage: "",
          line: "深水港-华迅",
          travel: "12",
          cycle: "5",
          abnormal: ""
        },
        {
          licence: "沪EC7513",
          warehouse: "6",
          deepwater: "",
          wharf: "",
          storage: "16",
          line: "普捷通-华迅",
          travel: "5",
          cycle: "6",
          abnormal: ""
        },
        {
          licence: "沪EB7193",
          warehouse: "15",
          deepwater: "20",
          wharf: "",
          storage: "",
          line: "华讯仓库-深水港",
          travel: "12",
          cycle: "8",
          abnormal: ""
        },
        {
          licence: "沪EC7513",
          warehouse: "",
          deepwater: "16",
          wharf: "40",
          storage: "",
          line: "深水港-洋山码头",
          travel: "42",
          cycle: "7",
          abnormal: ""
        },
        {
          licence: "沪EB7193",
          warehouse: "",
          deepwater: "30",
          wharf: "40",
          storage: "",
          line: "深水港-洋山码头",
          travel: "43",
          cycle: "5",
          abnormal: ""
        },
        {
          licence: "沪EC7513",
          warehouse: "",
          deepwater: "40",
          wharf: "58",
          storage: "",
          line: "洋山码头-深水港",
          travel: "52",
          cycle: "7",
          abnormal: ""
        },
        {
          licence: "沪EB7193",
          warehouse: "",
          deepwater: "",
          wharf: "106",
          storage: "20",
          line: "洋山码头-普捷通",
          travel: "60",
          cycle: "5",
          abnormal: ""
        },
        {
          licence: "沪EC7513",
          warehouse: "6",
          deepwater: "",
          wharf: "",
          storage: "15",
          line: "普捷通-华迅",
          travel: "5",
          cycle: "7",
          abnormal: ""
        },
        {
          licence: "沪EB7193",
          warehouse: "",
          deepwater: "30",
          wharf: "",
          storage: "45",
          line: "普捷通-深水港",
          travel: "29",
          cycle: "5",
          abnormal: ""
        }
      ],
      tableDataTow: []
    };
  },
  methods: {
    y_axis_data_display(max, value) {
      if (max <= 0) {
        value = "0";
      } else {
        let k = 1024;
        let c = Math.floor(Math.log(max) / Math.log(k));
        if (c == -1) {
          c = 0;
        }
        value = (value / Math.pow(k, c)).toFixed(0);
      }
      return value;
    },
    async Bearer() {
      var self = this;
      let data = {};
      data.fromTime = "2020-11-30T04:40:43.000Z";
      data.toTime = "2020-11-30T23:47:43.000Z";
      data.bizKey = [];
      let response = await this.apiService
        .post("/sinoslog-ops-service/sailingDate/queryTMSOrder", data)
        .then(res => {
          console.log(res);
        });
    },
    // async requestPlan() {
    //   let that = this;
    //   $.axios({
    //     method: "post",
    //     contenType: "application/json;charset=utf-8",
    //     url: "https://api-test.weikayun.com/tms/api/supplier/queryJobOrder",
    //     timeout: 60000,
    //     responseType: "json",
    //     data: {
    //       fromTime: "2020-01-01T12:00:00.000Z ",
    //       toTime: "2020-01-01T12:30:00.000Z ",
    //       bizKey: ["INV20080800327"]
    //     },
    //     beforeSend: function(request) {
    //       request.setRequestHeader("Authorization", "5555555");
    //     }
    //   }).then(res => {
    //     this.lading = res.data.shippingCompany;
    //   });
    // },
    handleIconClick() {
      if (!this.state1) {
        this.plateData = this.tableData;
        this.plateData2 = this.tableDataTow;
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    submitForm() {
      this.Bearer();
      console.log(this.form);
    },
    //车牌查询
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.licence
            .toLowerCase()
            .indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    loadAll() {
      return this.tableDataTow;
    },
    handleSelect(item) {
      this.state1 = item.licence;
      if (item.licence == "") {
        this.plateData = this.tableData;
        this.plateData2 = this.tableDataTow;
      } else {
        this.plateData = [];
        this.plateData2 = [];
        for (let i in this.tableData) {
          if (item.licence == this.tableData[i].licence) {
            this.plateData.push(this.tableData[i]);
          }
        }
        for (let i in this.tableDataTow) {
          if (item.licence == this.tableDataTow[i].licence) {
            this.plateData2.push(this.tableDataTow[i]);
          }
        }
      }
    },
    clickSkip(e) {
      this.plateData = [];
      for (let i in this.tableData) {
        if (e.origin + "-" + e.terminus == this.tableData[i].line) {
          this.plateData.push(this.tableData[i]);
        }
      }
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // 状态列字体颜色
      if (row.warehouse > 40 && columnIndex === 1) {
        return "color: red";
      } else if (row.warehouse <= 40 && columnIndex === 1) {
        return "color: #fff";
      } else if (row.deepwater > 40 && columnIndex === 2) {
        return "color: red";
      } else if (row.deepwater < 40 && columnIndex === 2) {
        return "color:  #fff";
      } else if (row.wharf > 40 && columnIndex === 3) {
        return "color: red";
      } else if (row.wharf < 40 && columnIndex === 3) {
        return "color:  #fff";
      } else if (row.storage > 40 && columnIndex === 4) {
        return "color: red";
      } else if (row.storage < 40 && columnIndex === 4) {
        return "color:  #fff";
      } else {
        return "color: #fff";
      }
    }
  }
};
</script>

<style>
html,
body {
  height: 100% !important;
}
.plan {
  height: 100%;
  background-color: #111f44;
}
.vehicle {
  background-image: -webkit-linear-gradient(bottom, #4faaff, #01effe);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 24px;
  font-weight: 700;
  padding-top: 20px;
  display: inline-block;
}
.tiem {
  position: absolute;
  left: -80px;
  top: 20px;
}
.tiem9 {
  position: absolute;
  right: 20px;
  top: 20px;
}
.time1 > .el-input__inner {
  border: 1px solid #2b3f9b;
  background-color: #2b3f9b;
  color: #fff !important;
}
.time2 {
  border: 1px solid #2b3f9b !important;
  background-color: #2b3f9b !important;
  border-radius: 6px !important;
}
.plan-main {
  padding-top: 20px;
}
.t_btn2 /deep/ .el-table > .el-table__body-wrapper {
  padding-right: 20px !important;
}
.t_btn2 /deep/ .el-table,
.el-table__expanded-cell {
  background-color: transparent !important;
}
.t_btn2 /deep/ .el-table tr {
  background-color: transparent !important;
}
/* .t_btn2 /deep/ .el-table tr:hover td {
  background-color: transparent !important;
} */
.t_btn2 > .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: transparent !important;
}
.t_btn2 /deep/ .el-table--enable-row-transition .el-table__body td,
.el-table .cell {
  background-color: transparent !important;
  font-size: 14px;
}
.t_btn2 /deep/ .el-table th.is-leaf {
  border-bottom: 1px solid #2b3f9b !important;
}
.t_btn2 /deep/ .el-table__row > td {
  border-bottom: 1px solid #2b3f9b !important;
}
.t_btn88 /deep/ .el-table__row > td > div {
  background-color: transparent;
  font-size: 14px;
  text-align: center;
}
.t_btn2 /deep/ .el-table__row:hover tr {
  background-color: #2b3f9b !important;
}
.el-table__body tr:hover > td {
  background-color: #134087 !important;
}
/* 清除底部横线 */
.el-table::before {
  height: 0px !important;
}
.gutter {
  display: none !important;
}
.plan-echarts {
  position: absolute;
  top: 8px;
  right: 40px;
}
.plan-echarts > .el-select > .el-input > .el-input__inner {
  background-color: #111f44;
  border: 1px solid #2b3f9b;
  color: #fff;
}
.plan-expectation {
  height: 12px;
  background-color: #fff;
  display: inline-block;
  position: relative;
}
.hue {
  background-color: rgb(29, 216, 29) !important;
}
.plan-practical {
  position: absolute;
  top: 4px;
  height: 4px;
  background-color: red;
}
.tiem9-inquire {
  color: #fff;
}
.tiem9-inline > .el-input > .el-input__inner {
  background-color: #111f44;
  border: 1px solid #2b3f9b;
  color: #fff;
}
.plan-designation {
  background-image: -webkit-linear-gradient(bottom, #4faaff, #01effe);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: left;
  font-size: 16px;
  font-weight: 700;
}
.scop-div {
  margin-left: 10px;
  width: 75px;
  display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/views/table/plan.vue